import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";

export default function Cookies() {
  return (
    <div data-testid="cookies-page">
      <Seo title="Cookie Policy" description="Cookie Policy for Domaleo Enterprise — how we use cookies and similar technologies on our website." />
      <section className="relative overflow-hidden pt-32 pb-16 lg:pt-40 lg:pb-20">
        <div className="absolute inset-0">
          <img src="https://images.unsplash.com/photo-1683322499436-f4383dd59f5a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920" alt="" className="h-full w-full object-cover" />
          <div className="absolute inset-0 hero-overlay" />
        </div>
        <div className="relative container-px mx-auto max-w-4xl">
          <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-white">Cookie Policy</h1>
          <p className="mt-3 text-slate-200">How Domaleo Enterprise uses cookies and similar technologies.</p>
        </div>
      </section>

      <section className="container-px mx-auto max-w-4xl py-16 lg:py-24">
        <Reveal className="space-y-8 text-muted-foreground leading-relaxed">
          <div>
            <h2 className="font-heading text-2xl font-semibold text-foreground">What Are Cookies?</h2>
            <p className="mt-3">Cookies are small text files stored on your device when you visit a website. They help the site function properly, remember your preferences, and provide information to the site owners about how the site is used.</p>
          </div>
          <div>
            <h2 className="font-heading text-2xl font-semibold text-foreground">How We Use Cookies</h2>
            <p className="mt-3">We use cookies and similar technologies for the following purposes:</p>
            <ul className="mt-3 list-disc space-y-2 pl-6">
              <li><span className="font-semibold text-foreground">Essential cookies</span> — required for core functionality such as page navigation and secure access to the admin area.</li>
              <li><span className="font-semibold text-foreground">Analytics cookies</span> — help us understand how visitors use our website (pages visited, country, and traffic trends) so we can improve our content and services.</li>
              <li><span className="font-semibold text-foreground">Preference cookies</span> — remember choices such as light or dark theme.</li>
            </ul>
          </div>
          <div>
            <h2 className="font-heading text-2xl font-semibold text-foreground">Third-Party Cookies</h2>
            <p className="mt-3">Some cookies may be set by third-party services we use for analytics and performance measurement. These providers may collect information in accordance with their own privacy policies.</p>
          </div>
          <div>
            <h2 className="font-heading text-2xl font-semibold text-foreground">Managing Cookies</h2>
            <p className="mt-3">You can control and delete cookies through your browser settings. Most browsers allow you to refuse or accept cookies and to remove existing ones. Please note that disabling certain cookies may affect how the website functions.</p>
          </div>
          <div>
            <h2 className="font-heading text-2xl font-semibold text-foreground">Changes to This Policy</h2>
            <p className="mt-3">We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated revision date.</p>
          </div>
          <div>
            <h2 className="font-heading text-2xl font-semibold text-foreground">Contact</h2>
            <p className="mt-3">If you have questions about our use of cookies, contact us at <a href="mailto:info@domaleogh.com" className="font-semibold text-primary hover:underline">info@domaleogh.com</a>.</p>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
